// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

export const isGenerativeAiStandardsRunUsageResult = objectOf({
  applies: boolean,
  limit: number,
  current_usage: number,
  remaining: number,
  resets_at: anyOf(string, nullOrUndefined),
});
